import artwork21648 from "../../../assets/curation/0/21648.jpg";
import artwork22191 from "../../../assets/curation/0/22191.jpg";
import artwork39091 from "../../../assets/curation/0/39091.jpg";
import artwork41881 from "../../../assets/curation/0/41881.jpg";
import artwork43687 from "../../../assets/curation/0/43687.jpg";
import artwork45304 from "../../../assets/curation/0/45304.jpg";
import artwork54039 from "../../../assets/curation/0/54039.jpg";
import artwork97635 from "../../../assets/curation/0/97635.jpg";
import artwork105049 from "../../../assets/curation/0/105049.jpg";
import artwork114424 from "../../../assets/curation/0/114424.jpg";
import artwork117951 from "../../../assets/curation/0/117951.jpg";
import artwork146722 from "../../../assets/curation/0/146722.jpg";

const data = {
  title: "PRISM",
  subtitle: "PRISMA #1",
  curated: "Curated by<br/>Amelie Maia and<br/>Tais Koshino",
  description: `
  Prism is an artefact that disperses a beam of white light into its component colors. It can also deviate, rotate and displace a beam of light, thus forming an image from its angles, shapes and materials. 
  <br/>PRISMA NFTs are the ones that show us colors, they displace, deviate and change the usual image. These NFTs present to us different ways of creating and imagining a more diverse art world.
  `,
  artists: [
    {
      artist: ["Eduardo Moreira"],
      title: "a wave of black snow",
      profile: ["tz1RP2JCzGLH2xCXhue5oirjrFB1Zdu8E5vm"],
      description:
        "a work of speculative imagination that seeks to see what exist in the infinite. by: @terremofo",
      objktID: 54039,
      artwork: artwork54039,
    },
    {
      artist: ["Eve Queiroz"],
      title: "Sharing Knowledge",
      profile: ["tz1ZcgrJashtPEaiGJbz48XMdrMGxHhjyEWL"],
      description: "Sharing Knowledge - 2021 - GIF - 800x680",
      objktID: 45304,
      artwork: artwork45304,
    },
    {
      artist: ["Gwyn9x"],
      title: "Face to Face",
      profile: ["tz1Rsrx429S8HJn9nCxuKd8SaHgkcfjttGeC"],
      description:
        "Pseudonymous online lives help many queer and transgender people own, build, and refine our identity. For a time, virtual avatars become our real mirror image. 21E16V.",
      objktID: 97635,
      artwork: artwork97635,
    },
    {
      artist: ["Iúna Mariá"],
      title: "troca de pele - change skin 🐍",
      profile: ["tz1TK7seCqm65kUy9ysX5y8R4xDu9NDCf93k"],
      description:
        "Digital illustration by Iúna Mariá edited on Adobe Photoshop and illustrator, dimensions 5400x7200, file size 4,23 MB (4.441.998 bytes). Ilustração digital por Iúna Mariá feita no Adobe Photoshop e Illustrator, dimensões 5400x7200, tamanho do arquivo 4,23 MB (4.441.998 bytes). 2021.",
      objktID: 146722,
      artwork: artwork146722,
    },
    {
      artist: ["Lauzaki"],
      title: "Interplanetary abstract #1",
      profile: ["tz1ZTDCfahwoYqF6sJmxTmbtGDskPoAateJX"],
      description:
        "Rear view of the left booster as the ship leaves Orion. mp4 1470x680 3s",
      objktID: 21648,
      artwork: artwork21648,
    },
    {
      artist: ["Linda Dounia Rebei"],
      title: "sandwyrm dance/fourth flow",
      profile: ["tz1UifYfgYwmhxhcRU2NDBYwj4i7Jf8pu2bz"],
      description: "",
      objktID: 117951,
      artwork: artwork117951,
    },

    {
      artist: ["Mariana Destro"],
      title: "Things that look worse in paintings-I",
      profile: ["tz1My9S2yAkvFjGqZpywmWVDidy3BuRtVK4d"],
      description:
        "GIF from Things that look worse in paintings, series of images posted on Instagram stories throughout 2020/2021 all taken with smartphone cameras by Mariana Destro (@mariana9destro), 640 × 1136 px.",
      objktID: 39091,
      artwork: artwork39091,
    },
    {
      artist: ["Mirjam Dalire", "Marlon Hacla"],
      title: "Mariposa",
      profile: [
        "tz1Y8Pzjd6QuwwS9qREaKr1hvW4KMG2mtHNd",
        "tz2G5SBeAJVbiE1icji3P59Lx8EvcwMLEHp3",
      ],
      description:
        "An interactive portrait generated using a GAN trained on Fernando Amorsolo's paintings, stretched on a digital 3D canvas. Image: Marlon Hacla (@sintang_ligalig) 3D canvas: Mirjam Dalire (@salawaki_3000)",
      objktID: 41881,
      artwork: artwork41881,
    },
    {
      artist: ["Sharareh Faryadi"],
      title: "Eyes of the Earth",
      profile: ["tz1h1S2w7rTSJ5zSeRPtWtRAoCVEkkCjBsKQ"],
      description: "In the eyes of the earth, who are we?",
      objktID: 105049,
      artwork: artwork105049,
    },
    {
      artist: ["Terra Assunção", "Yluztra"],
      title: "𝕛𝕒𝕘𝕦𝕒𝕣𝕒",
      profile: [
        "tz1Ki1EqqFDbR5a263E7qZcBZoNDxq6TV5AC",
        "tz1NcMLkFhHGnfCch4GX5nSGJ6pY7797iofp",
      ],
      description:
        "𝕛𝕒𝕘𝕦𝕒𝕣𝕒 is a collaborative art piece between Terra Assunção ( @terra_assuncao ) and Yluztra ( @yluztra ) , two brazilians visual artists working on 3d and 2d art with nature thematics ☀",
      objktID: 43687,
      artwork: artwork43687,
    },
    {
      artist: ["Violet Forest"],
      title: "Isaus: Electric Quartz Researcher & Flora Whisperer",
      profile: ["tz1YMqQQme7jcERyk2586QDT9fqWGCz9L2fQ"],
      description:
        "(From the series “GAN-Generated Fancy Insect Aliens in Intricate Veils”) // Isaus is tall, with translucent skin and long gray hair. She wears a pearlescent and intricately embellished jumpsuit and helmet and carries scientific tools and scanners. Isaus is reflective and brave. She speaks with a whispery voice. // Isaus is fascinated by biology and chemistry. Her interest and fascination stems from the ancient writings found in ancient ruins across the galaxy and the discovery that the organic molecules within her specie's skin produces electricity like electrical charges in batteries when in contact with the native flora of her planet. This is a common phenomenon for the native flora of this planet as its soil produces both minerals, like silicate quartz, and salts. When she touches these, an electronic reaction ensues. The more her specie's skin contacts this material and becomes electrified, the faster they develop an innate connection and are capable of sensing and communicating with other flora like an instinctual link. // Isaus's partner in research is Mase Robail, a male scientist, master of the research vessel Eratosthenes. His spacecraft appears to be organic, its chitinous shell set with compound sensor clusters. Isaus and Mase work together and their ship is always traveling towards some unknown region in order to gather more data to better understand the nature of the native flora on this planet.",
      objktID: 114424,
      artwork: artwork114424,
    },
    {
      artist: ["Xyk"],
      title: "Abstract #2",
      profile: ["tz1Lr2jfgtE3mFHBtTrETs82nWdsuSsYAxjZ"],
      description:
        "watercolour, nankim and grafitti on paper 300g/m² | size 14x23cm / 3286x5444px #xyk",
      objktID: 22191,
      artwork: artwork22191,
    },
  ],
};

export default data;
